import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProductShowcase } from './components/ProductShowcase';
import { WhyRewayz } from './components/WhyRewayz';
import { Solution } from './components/Solution';
import { Results } from './components/Results';
import { CaseStudies } from './components/CaseStudies';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { BackgroundDecor } from './components/BackgroundDecor';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="31ayplzmqfjy8">
      <div className="relative min-h-screen w-full overflow-hidden bg-[#F7F4EE] font-body antialiased" data-id="element-1" data-mp="31c9uy3vtszrg">
        <BackgroundDecor data-id="element-2" data-mp="2wifhhi6tdh0t" />

        <div className="relative" data-id="element-3" data-mp="2wi5mfg6wwjo9">
          <Header data-id="element-4" data-mp="28tmg367fagyt" />
          <main data-id="element-5" data-mp="28t4kmbsl46ry">
            <Hero data-id="element-6" data-mp="28sl48zil1qg1" />
            <ProductShowcase data-id="element-7" data-mp="28s2zfehuu3wi" />
            <WhyRewayz data-id="element-8" data-mp="23vuoyeelqyvo" />
            <Solution data-id="element-9" data-mp="23ujk0b9f7l2z" />
            <Results data-id="element-10" data-mp="23v2td3l0915e" />
            <CaseStudies data-id="element-11" data-mp="3ijxpqrsp22kf" />
            <FinalCta data-id="element-12" data-mp="3ikh5q2ysagvt" />
          </main>
          <Footer data-id="element-13" data-mp="3ijpbowku4r7n" />
        </div>
      </div>
    </LanguageProvider>;
}